export const gradients = {
    HYPE: 'linear-gradient(to bottom, #a209fe, #2471fe)', // hype
    AGILE: 'linear-gradient(to bottom, #006cee, #01b2ff)', // agile
    POWER: 'linear-gradient(to bottom, #25baff, #30fefa)', // power
    STRENGTH: 'linear-gradient(to bottom, #33fffe, #02efac)', // strength
    KETTLE: 'linear-gradient(to bottom, #00eeba, #1cff01)', // kettle
    CRUSH: 'linear-gradient(to bottom, #f8e71d, #fe5013)', // crush
    BURN: 'linear-gradient(to bottom, #fb1b1b, #fa7827)', // burn
    FLEX: 'linear-gradient(to bottom, #fb3e1b, #fa2795)', // flex
    GAINS: 'linear-gradient(to bottom, #f900fc, #f90071)', // gains
    PACE: 'linear-gradient(to bottom, #8928fa, #df0ffe)', // pace
    DEFAULT_ORANGE: 'radial-gradient(circle at 48% 3%, #fb721b, #fd3260)',
};



// WEBPACK FOOTER //
// ./src/Constants/gradients.js